import { useEffect, useState } from 'react';
import { Gift } from 'lucide-react';
import { api } from './api';

interface Cp { code: string; percent_off: number; title?: string | null; source: string; used_at: string | null; created_at: string }
const KEY = 'ck.coupons.seen';

/** Pops up once when the team has given the client a new personal coupon (for example after approving a request). */
export function CouponNotice({ buy }: { buy: () => void }) {
  const [c, setC] = useState<Cp | null>(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    const check = () => api.get<{ coupons: Cp[] }>('/v1/me/offers').then((r) => {
      let seen: string[] = []; try { seen = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { /* none */ }
      const fresh = r.coupons.filter((x) => !x.used_at && !seen.includes(x.code) && Date.now() - new Date(x.created_at).getTime() < 14 * 864e5);
      if (fresh[0]) setC(fresh[0]);
    }).catch(() => undefined);
    void check();
    const t = setInterval(() => { if (!document.hidden) void check(); }, 60_000);
    return () => clearInterval(t);
  }, []);
  if (!c) return null;
  const close = () => { try { const s: string[] = JSON.parse(localStorage.getItem(KEY) || '[]'); localStorage.setItem(KEY, JSON.stringify([...s, c.code].slice(-100))); } catch { /* ok */ } setC(null); };
  return (
    <div className="bt-ov" onMouseDown={(e) => { if (e.target === e.currentTarget) close(); }}>
      <div className="cpn" role="dialog" aria-modal="true" aria-label="Coupon received">
        <button className="bt-x cpn-x" onClick={close} aria-label="Close">×</button>
        <span className="un-ic" aria-hidden="true"><Gift /></span>
        <span className="gd-live gold">COUPON RECEIVED</span>
        <h2>Your coupon has been created!</h2>
        <p>{c.title ? `${c.title}. ` : ''}Copy your code and paste it at checkout to get <b>{c.percent_off}% off</b>.</p>
        <div className="cpn-code notranslate"><span>{c.code}</span><button onClick={() => { void navigator.clipboard?.writeText(c.code); setCopied(true); }}>{copied ? 'Copied ✓' : 'Copy'}</button></div>
        <div className="cpn-pct" aria-hidden="true"><b>{c.percent_off}%</b><small>OFF</small></div>
        <div className="cpn-b"><button className="gd-new" onClick={() => { try { sessionStorage.setItem('ck.coupon', c.code); } catch { /* ok */ } close(); buy(); }}>Use it now <i aria-hidden="true">›</i></button><button className="gd-ghost" onClick={close}>Later</button></div>
      </div>
    </div>
  );
}
